module.exports = __webpack_public_path__ + "static/gold_forged_sentinel-7898fe2159a44df3bc5fdfd06a3edcc6.jpeg";